/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Option } from './Option';
import { PermissionException } from './PermissionException';
const DisabledSettingExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['disabledSetting', Option, 'disabled_setting'],
]), PermissionException);
export class DisabledSettingException extends PermissionException {
    static decode(input) {
        return DisabledSettingExceptionParser.decode(input).map(res => new DisabledSettingException(res));
    }
    static unsafeDecode(input) {
        return DisabledSettingException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DisabledSettingExceptionParser.encode(data);
    }
    static schema() {
        return DisabledSettingExceptionParser.schema();
    }
}
